export default "__VITE_ASSET__V0n5zgBG__"